import React from 'react';
import PropTypes from 'prop-types';

export default class CommentsList extends React.Component {
    divideByPage(list) {
        let lists = [];
        list.forEach(item => {
            if (!Array.isArray(lists[item.page])) {
                lists[item.page] = [];
            }
            lists[item.page].push(item);
        });
        return lists;
    }

    renderList(list) {
        // console.log('CommentsList renderList', list);
        if (list && list.length > 0) {
            // reordering by y

            let comments = list.sort((a, b) => {
                return a.y - b.y;
            });

            return comments.map(item => {
                if (!item) return null;
                let isSelected =
                    this.props.selectedId === item.annotation ||
                    this.props.selectedId === item.uuid; // for compatibility
                // console.log('renderComments key', item.uuid);

                return (
                    <div
                        key={item.uuid}
                        className="comment-list-item"
                        data-page={item.page}
                        style={{ fontWeight: isSelected ? 600 : 200 }}
                        onClick={this.props.onCommentClick.bind(this, item)}
                    >
                        {item.content}
                    </div>
                );
            });
        }
        return <div className="comment-list-item">No comments</div>;
    }

    renderLists = () => {
        if (!this.props.comments || this.props.comments.length < 1) {
            return <div className="comment-list-item">No comments</div>;
        }

        let lists = this.divideByPage(this.props.comments);
        let renders = [];
        lists.forEach(list => {
            if (list.length > 0) {
                renders.push(this.renderList(list));
            }
        });
        return renders.map((page, i) => {
            // console.log('---CommentsList page', page);
            return (
                <div key={i} className="comment-list-page-block">
                    <div className="comment-list-page">Page {page[0].props['data-page']}</div>
                    <div className="comment-list-page-comments">{page}</div>
                </div>
            );
        });
    };

    render() {
        // console.log('CommentsList render', this.props);
        return (
            <div id="comment-wrapper" className={this.props.show ? '' : 'hidden'}>
                <label className="comment-panel-toggler" onClick={this.props.toggle}>
                    {this.props.toggleIcon}
                </label>

                <div className="comment-wrapper-header">
                    <div className="comment-wrapper-header-text">Comments</div>
                </div>

                <div className="comment-list">
                    <div className="comment-list-container" ref={el => (this.listContainer = el)}>
                        {this.renderLists()}
                    </div>
                </div>
            </div>
        );
    }
}

CommentsList.propTypes = {
    comments: PropTypes.arrayOf(PropTypes.shape({})),
    show: PropTypes.bool,
    selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onCommentClick: PropTypes.func,
    toggle: PropTypes.func,
    toggleIcon: PropTypes.any,
};

CommentsList.defaultProps = {
    comments: [],
    show: false,
    selectedId: null,
    onCommentClick: null,
    toggle: null,
};



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/CommentsList.js